import Alpine from 'alpinejs';
import { searchBoxFactory } from './searchbox';

// TODO: Remove after releasing Gravity Search project (ENABLE_GRAVITY_SEARCH)
// If the FF is enabled we don't need to load the Alpine component of the old search box
if (!window.siteData.global.isGravitySearchEnabled) {
    Alpine.data('searchbox', (browserStorageKey: string, maxSuggestion: number) =>
        searchBoxFactory(browserStorageKey, maxSuggestion)
    );
}
